// использовать только в крайнем случае
export const redicrectWithUpdatePage = () => {
    window.location.href = '/signIn';
  };
  